// src/store/modules/legalDocs.js
import legalDocsService from '@/services/legalDocsService';

export default {
  namespaced: true,
  state: {
    legalDocs: [],
    currentDoc: null,
    loading: false,
    error: null
  },
  mutations: {
    SET_LEGAL_DOCS(state, legalDocs) {
      state.legalDocs = legalDocs;
    },
    SET_CURRENT_DOC(state, doc) {
      state.currentDoc = doc;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    fetchLegalDocs({ commit }, type) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      return legalDocsService.getLegalDocs(type)
        .then(response => {
          commit('SET_LEGAL_DOCS', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch(error => {
          commit('SET_ERROR', error);
          commit('SET_LOADING', false);
          throw error;
        });
    },
    fetchLegalDoc({ commit }, id) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      return legalDocsService.getLegalDoc(id)
        .then(response => {
          commit('SET_CURRENT_DOC', response.data);
          commit('SET_LOADING', false);
          return response.data;
        })
        .catch(error => {
          commit('SET_ERROR', error);
          commit('SET_LOADING', false);
          throw error;
        });
    }
  },
  getters: {
    getDocByType: state => type => {
      return state.legalDocs.find(doc => doc.type === type);
    }
  }
};